import {ChangeDetectorRef, Component, Inject, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {EventsService} from '../../../events/events.service';
import {GlobalService} from '../../../../global.service';
import {AuthenticationService} from '../../../../authentication.service';
import {MatDialog} from '@angular/material';
import {TeamEventsService} from '../../../team-events/team-events.service';
import {UsersService} from '../../../users/users.service';
import {HttpClient, HttpEvent, HttpEventType} from '@angular/common/http';
import {SortablejsOptions} from 'ngx-sortablejs';
import {teamsService} from '../../../teams/teams.service';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {SeasonsService} from '../../seasons.service';


@Component({
  selector: 'elastic-team-sign-up',
  templateUrl: './team-signup.component.html',
  styleUrls: ['./team-signup.component.scss']
})
export class TeamSignupComponent implements OnInit {

  eventId: any;
  event: any;
  raceId: any;
  eventLoaded = false;
  desktopGap = '24px';
  mobileGap = '16px';

  newdriver = 'team';

  invitationcode = '';
  invitationValid = false;

  cars = [];

  signup = {
    p_id : 0,
    team_id : 0,
    teamname: '',
    drivers: [],
    screenshot: {},
    car_pic : '',
    invitationValid: false,
    livery_approved: false,
    livery_zip : '',
    invited: 0,
    livery: 0
  };

  teamdrivers = [];

  myteam = [];
  driveradder: any;
  driveradder2: any;

  groupOptions: SortablejsOptions = {
    group: 'testGroup',
    handle: '.drag-handle',
    animation: 300
  };

  language = navigator.language.includes('de') ? 'german' : 'english';

  desktopWidth = `0 0 calc(33.3333% - ${this.desktopGap}`;
  tabletWidth = `0 0 calc(33.3333% - ${this.desktopGap}`;
  smallTabletWidth = `0 0 calc(50% - ${this.mobileGap}`;
  mobileWidth = `0 0 calc(100% - ${this.mobileGap}`;

  activeCarClasses = [];
  driversearch: any;
  alldrivers = [];

  screenshot: File;
  zipfile: File;

  liveries = [];

  availableClasses = [];

  constructor( @Inject(MAT_DIALOG_DATA) public data: any,
               public dialogRef: MatDialogRef<TeamSignupComponent>,
               private route: ActivatedRoute,
               private router: Router,
               private eventsService: EventsService,
               private globalServie: GlobalService,
               private globalService: GlobalService,
               private auth: AuthenticationService,
               private dialog: MatDialog,
               private cdr: ChangeDetectorRef,
               private teamEventsService: TeamEventsService,
               private usersService: UsersService,
               private teamsService: teamsService,
               private seasonsService: SeasonsService,
               private authenticationService: AuthenticationService,
               private http: HttpClient) { }

  ngOnInit() {

    this.event = this.data.event;
    this.eventId = this.data.event.event_id;
    this.raceId = this.data.race.race_id;

    this.seasonsService.getAvailableCars(this.data.event.event_id, this.raceId).subscribe( (data: any) => {
      if (data) {
        this.cars = data;
      }
    });

    console.log(this.event.class_sr_req);

    if (!this.auth.isLoggedIn()) {
      alert('Please login first!');
      this.router.navigateByUrl('/');
    }

    if (!this.auth.isLicenseValid()) {
      this.router.navigateByUrl('/invalid-license');
    }



    this.getData();
    this.getUsersLiveries();

    this.signup.drivers.push({vorname: this.auth.currentUser.vorname, nachname: this.auth.currentUser.nachname, userid: this.auth.currentUser.id, driver_no: 1});

  }

  getUsersLiveries() {
    if (this.data.event.sim_id == 1) {
      this.globalService.getUsersLiveries().subscribe( (data: any) => {
        if (data.length > 0) {
          this.liveries = data;
          this.cdr.detectChanges();
        }
      });
    }
  }

  adder(selected) {
    console.log(selected);
    const id = Number(selected.id);
    let isIn = false;

    this.signup.drivers.forEach((driver) => {
      if (Number(id) === Number(driver.userid)) {
        isIn = true;
      }
    });

    if (!isIn) {

      if (Number(selected.safety_rating) < Number(this.event.minimum_sr) && !this.invitationValid) {
        alert("Can not add driver. Safety rating is to low for this event!");
      } else {

        if (Number(selected.cc_rating) < Number(this.event.minimum_elo) && !this.invitationValid) {
          alert("Can not add driver. ELO rating is to low for this event!");
        } else {
          this.signup.drivers.push({vorname: selected.vorname, nachname: selected.nachname, userid: Number(selected.id)});
          this.driversearch = '';
        }
      }
      selected = {};
    } else {
      alert("Driver is already in the line up!");
    }

  }


  changeTeam() {
    this.myteam.forEach( (team) => {
      if (team.team_id == this.signup.team_id) {
        this.signup.teamname = team.teamname;
        this.teamsService.getTeam(team.team_id).subscribe(
          ( response2: HttpEvent<any> ) => {
            switch (response2.type) {
              case HttpEventType.Response:
                this.teamdrivers = [];
                response2.body.data.members.forEach((item) => {
                  this.teamdrivers.push(item);
                });
                this.cdr.detectChanges();
                break;
            }
          });
        this.cdr.detectChanges();
      }
    });
  }

  getData() {

    this.teamEventsService.getRegistrationSeason(this.eventId, this.raceId).subscribe((data: any) => {
      if (data) {
        this.signup = data;


        this.cdr.detectChanges();
      }
    });

    this.teamEventsService.getAvailableClasses(this.eventId, this.raceId).subscribe( (data: any) => {
      if (data) {
        this.availableClasses = data;
      }
    });


    this.usersService.getMyTeam().subscribe(
      ( response: HttpEvent<any> ) => {
        switch (response.type) {
          case HttpEventType.Response:
            this.myteam = response.body;
            if (this.myteam[0].team_id) {
              this.signup.team_id = this.myteam[0].team_id;
              this.signup.teamname = this.myteam[0].teamname;
            } else {
              alert('You are not part of a team! You can unfortunately not register a car for that race!');
              this.dialogRef.close();
            }
            this.teamsService.getTeam(this.myteam[0].team_id).subscribe(
              ( response2: HttpEvent<any> ) => {
                switch (response2.type) {
                  case HttpEventType.Response:
                    response2.body.data.members.forEach((item) => {
                      this.teamdrivers.push(item);
                    });
                    this.cdr.detectChanges();
                    break;
                }
              });
            this.cdr.detectChanges();
            break;
        }
      });

    this.teamEventsService.getEvent(this.eventId).subscribe((data: any) => {
      this.eventLoaded = true;
      this.event = data;

      this.cdr.detectChanges();
      console.log(this.event);
      this.event.settings.championship_settings.car_classes.forEach(function(carClass) {
        this.activeCarClasses.push(carClass.class);
      }, this);
    });

    /*
    this.usersService.getAllUsers().subscribe((data: any) => {
      this.alldrivers = data;
      this.cdr.detectChanges();
    });
    */

  }

  save() {

    if (this.signup.drivers.length <= this.event.team_max_drivers && this.signup.drivers.length >= this.event.team_min_drivers) {

      this.signup.drivers.forEach( (driver: any) => {
        this.cars.forEach( (car: any) => {
          // @ts-ignore
          if (car.car_id == this.signup.car_model) {
            if (this.data.event.class_sr_req[car.class] != undefined) {
              if (driver.safety_rating < this.data.event.class_sr_req[car.class]) {
                alert('Driver ' + driver.vorname + ' ' + driver.nachname + ' has not enough safety rating for this car class!');
                return false;
              }
            }
          }
        });

      });

      this.teamEventsService.signupSeasonRace(this.signup, this.eventId, this.raceId).subscribe((data: any) => {

        if (data.success) {
          alert('Signed Up!');
        } else {
          alert(data.message);
        }

        this.dialogRef.close('registered');

        this.teamEventsService.getRegistrationSeason(this.eventId, this.raceId).subscribe((data: any) => {
          if (data) {
            this.signup = data;
            this.cdr.detectChanges();
          }
        });
      });
    } else {
      alert('Your team has to many or to less drivers. Event settings are: minimum ' + this.event.team_min_drivers + ' and maximum ' + this.event.team_max_drivers + ' drivers!');
    }

  }

  withdraw() {
    if (confirm('Do you really wanna withdraw from this event?')) {
      this.teamEventsService.withdraw(this.eventId, this.signup.p_id).subscribe((data: any) => {
        if (data) {
          alert(data.message);
          this.router.navigateByUrl('/endurance');
        }
      });
    }
  }

  checkDisabled(driver): boolean {

    if (this.signup.drivers.indexOf({userid: driver.id}) != -1) {
      return true;
    }

    if (driver.safety_rating < this.event.minimum_sr && !this.invitationValid) {
      return true;
    }
    if (driver.cc_rating < this.event.minimum_elo && !this.invitationValid) {
      return true;
    }

    if (this.globalService.licenseRanks[driver.license]*1 < this.globalService.licenseRanks[this.event.min_license]*1 && !this.invitationValid) {
      return true;
    }

    return false;
  }

  searchDrivers() {
    if (this.driversearch.length >= 3) {
      this.usersService.searchUsers(this.driversearch).subscribe((data: any) => {
        this.alldrivers = data;
        this.cdr.detectChanges();
      });
    }
  }

  checkSrClass(cl) {
    //console.log("Class: " + cl);
    //console.log("Expected SR for class: "+ this.data.event.class_sr_req[cl]);
    //console.log("User SR: " + this.authenticationService.getUserSr());

    if (this.data.event.class_sr_req[cl]*1 > this.authenticationService.getUserSr()*1) {
      //console.log("NO! " + cl);
      return false;
    } else {
      //console.log("YES! " + cl);
      return true;
    }

  }


}
